<template>
  <div class="blood-oxygen-unit">
    <div class="blood-oxygen-unit-left">
      <p>{{ title }}：</p>
      <input class="blood-oxygen-unit-left-value" :value="value" />
    </div>
    <p class="blood-oxygen-unit-unit">{{ unit }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String|Number,
    unit: String,
  },
};
</script>

<style lang="scss" scoped>

.blood-oxygen-unit {
  color: black;
  font-size: rem(14);
  height: rem(30);
  display: flex;
  align-items: center;

  &-left {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-value{
      text-align: right;
      width: rem(50);
    }
  }

  &-unit {
    margin-left: rem(20);
  }
}
</style>